import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { AuthContext } from '@@/contexts/AuthContext';
import { ResultValue } from '@@/types/ApiResult';
import { DfcApiClient } from '../api/dfc-api-client';
import { PollySynthesizePayload, PollySynthesizeResponse } from '../api/api-tools';

export const usePollySynthesize = () => {
  const { instanceData } = useContext(AuthContext);

  return useMutation({
    mutationFn: async (payload: PollySynthesizePayload): Promise<PollySynthesizeResponse> => {
      if (!instanceData?.instanceId) {
        throw new Error('Missing required context data');
      }

      const dfcApiClient = new DfcApiClient();
      const result = await dfcApiClient.tools.pollySynthesize({
        input: payload,
        queryString: {
          instanceId: instanceData.instanceId,
          region: instanceData.region
        }
      });

      if (!ResultValue.ok(result)) {
        throw new Error(result.message ?? 'Failed to synthesize speech');
      }

      return result.data;
    }
  });
};
